import React, { FC } from "react";
import UniversalTable from "../../organization/table/UniTable";
import { IStation } from "../../../models/IUser";
import { WithModified } from "./utils/modifiedFields";

interface PopupStationsTableProps {
  data: WithModified<IStation>[];
  onCellChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    stationId?: number,
  ) => void;
}

export const PopupStationsTable: FC<PopupStationsTableProps> = ({
  data,
  onCellChange,
}) => {
  return (
    <UniversalTable
      data={data}
      type="stationsInModule"
      setOrg={() => {}}
      Edit={() => {}}
      goto={undefined}
      onCellChange={onCellChange}
    />
  );
};
